/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Field_ExtractionInputs */

const en_inbound_field_extraction = /** @type {(inputs: Inbound_Field_ExtractionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extraction tool`)
};

/**
* | output |
* | --- |
* | "Extraction tool" |
*
* @param {Inbound_Field_ExtractionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_field_extraction = /** @type {((inputs?: Inbound_Field_ExtractionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Field_ExtractionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_field_extraction(inputs)
});